// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.6.1
//   protoc               unknown
// source: models/claim.proto

/* eslint-disable */
import { BinaryReader, BinaryWriter } from "@bufbuild/protobuf/wire";
import { ClaimStatus, claimStatusFromJSON, claimStatusToJSON, OsType, osTypeFromJSON, osTypeToJSON } from "./global";

export const protobufPackage = "models";

/** Claim result defines the status of claim attempt on a specific device ID. */
export interface ClaimResult {
  /** DeviceId defines MAC address of the device. */
  deviceId: string;
  /** ClaimCode defines the claim code of the device. */
  claimCode: string;
  /** ClaimStatus defines the claim status of the device */
  claimStatus: ClaimStatus;
  /** SerialNumber defines the device's serial number. */
  serialNumber: string;
  /** ModelName defines the device's model name. */
  modelName: string;
  /** OsType defines the OS type fo the device. */
  osType: OsType;
  /** Monitored indicates that the device is in monitoring mode, i.e. unmanaged. */
  monitored: boolean;
}

export interface AdjacentDevice {
  /** DeviceId defines MAC address of the device. */
  deviceId: string;
  /** NodeId defines the unique internal identifier of the node for the device. */
  nodeId: string;
  /** NodeName defines the name of node, as well as its hostname of the device. */
  nodeName: string;
  /** FabricId defines the identifier of parent Fabric object of the device. */
  fabricId: string;
  /** FabricName defines the name of parent Fabric object of the device. */
  fabricName: string;
  /** PortName defines the device local port that connects to the discovered device */
  portName: string;
}

/** Discovered device includes the device and connection info of a discovered device that adjacent to the claimed device */
export interface DiscoveredDevice {
  /** DeviceId defines MAC address of the discovered device. */
  deviceId: string;
  /** DeviceName defines the name of the discovered device. */
  deviceName: string;
  /** SerialNumber defines discovered device's serial number. */
  serialNumber: string;
  /** ModelName defines discovered device's model name. */
  modelName: string;
  /** ConnectedDevices defines the list of adjacent devices that current device connects to */
  connectedDevices: AdjacentDevice[];
}

/** Claimed device includes the device info of a claimed device */
export interface ClaimedDevice {
  /** DeviceId defines MAC address of the claimed device. */
  deviceId: string;
  /** DeviceName defines the name of the claimed device. */
  deviceName: string;
  /** FabricId defines the identifier of parent Fabric object of the device. */
  fabricId: string;
}

function createBaseClaimResult(): ClaimResult {
  return { deviceId: "", claimCode: "", claimStatus: 0, serialNumber: "", modelName: "", osType: 0, monitored: false };
}

export const ClaimResult: MessageFns<ClaimResult> = {
  encode(message: ClaimResult, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.deviceId !== "") {
      writer.uint32(10).string(message.deviceId);
    }
    if (message.claimCode !== "") {
      writer.uint32(18).string(message.claimCode);
    }
    if (message.claimStatus !== 0) {
      writer.uint32(24).int32(message.claimStatus);
    }
    if (message.serialNumber !== "") {
      writer.uint32(34).string(message.serialNumber);
    }
    if (message.modelName !== "") {
      writer.uint32(42).string(message.modelName);
    }
    if (message.osType !== 0) {
      writer.uint32(48).int32(message.osType);
    }
    if (message.monitored !== false) {
      writer.uint32(56).bool(message.monitored);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ClaimResult {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseClaimResult();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.deviceId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.claimCode = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 24) {
            break;
          }

          message.claimStatus = reader.int32() as any;
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.serialNumber = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.modelName = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 48) {
            break;
          }

          message.osType = reader.int32() as any;
          continue;
        }
        case 7: {
          if (tag !== 56) {
            break;
          }

          message.monitored = reader.bool();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ClaimResult {
    return {
      deviceId: isSet(object.deviceId) ? globalThis.String(object.deviceId) : "",
      claimCode: isSet(object.claimCode) ? globalThis.String(object.claimCode) : "",
      claimStatus: isSet(object.claimStatus) ? claimStatusFromJSON(object.claimStatus) : 0,
      serialNumber: isSet(object.serialNumber) ? globalThis.String(object.serialNumber) : "",
      modelName: isSet(object.modelName) ? globalThis.String(object.modelName) : "",
      osType: isSet(object.osType) ? osTypeFromJSON(object.osType) : 0,
      monitored: isSet(object.monitored) ? globalThis.Boolean(object.monitored) : false,
    };
  },

  toJSON(message: ClaimResult): unknown {
    const obj: any = {};
    if (message.deviceId !== "") {
      obj.deviceId = message.deviceId;
    }
    if (message.claimCode !== "") {
      obj.claimCode = message.claimCode;
    }
    if (message.claimStatus !== 0) {
      obj.claimStatus = claimStatusToJSON(message.claimStatus);
    }
    if (message.serialNumber !== "") {
      obj.serialNumber = message.serialNumber;
    }
    if (message.modelName !== "") {
      obj.modelName = message.modelName;
    }
    if (message.osType !== 0) {
      obj.osType = osTypeToJSON(message.osType);
    }
    if (message.monitored !== false) {
      obj.monitored = message.monitored;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ClaimResult>, I>>(base?: I): ClaimResult {
    return ClaimResult.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ClaimResult>, I>>(object: I): ClaimResult {
    const message = createBaseClaimResult();
    message.deviceId = object.deviceId ?? "";
    message.claimCode = object.claimCode ?? "";
    message.claimStatus = object.claimStatus ?? 0;
    message.serialNumber = object.serialNumber ?? "";
    message.modelName = object.modelName ?? "";
    message.osType = object.osType ?? 0;
    message.monitored = object.monitored ?? false;
    return message;
  },
};

function createBaseAdjacentDevice(): AdjacentDevice {
  return { deviceId: "", nodeId: "", nodeName: "", fabricId: "", fabricName: "", portName: "" };
}

export const AdjacentDevice: MessageFns<AdjacentDevice> = {
  encode(message: AdjacentDevice, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.deviceId !== "") {
      writer.uint32(10).string(message.deviceId);
    }
    if (message.nodeId !== "") {
      writer.uint32(18).string(message.nodeId);
    }
    if (message.nodeName !== "") {
      writer.uint32(26).string(message.nodeName);
    }
    if (message.fabricId !== "") {
      writer.uint32(34).string(message.fabricId);
    }
    if (message.fabricName !== "") {
      writer.uint32(42).string(message.fabricName);
    }
    if (message.portName !== "") {
      writer.uint32(50).string(message.portName);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): AdjacentDevice {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseAdjacentDevice();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.deviceId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.nodeId = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.nodeName = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.fabricName = reader.string();
          continue;
        }
        case 6: {
          if (tag !== 50) {
            break;
          }

          message.portName = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): AdjacentDevice {
    return {
      deviceId: isSet(object.deviceId) ? globalThis.String(object.deviceId) : "",
      nodeId: isSet(object.nodeId) ? globalThis.String(object.nodeId) : "",
      nodeName: isSet(object.nodeName) ? globalThis.String(object.nodeName) : "",
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
      fabricName: isSet(object.fabricName) ? globalThis.String(object.fabricName) : "",
      portName: isSet(object.portName) ? globalThis.String(object.portName) : "",
    };
  },

  toJSON(message: AdjacentDevice): unknown {
    const obj: any = {};
    if (message.deviceId !== "") {
      obj.deviceId = message.deviceId;
    }
    if (message.nodeId !== "") {
      obj.nodeId = message.nodeId;
    }
    if (message.nodeName !== "") {
      obj.nodeName = message.nodeName;
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    if (message.fabricName !== "") {
      obj.fabricName = message.fabricName;
    }
    if (message.portName !== "") {
      obj.portName = message.portName;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<AdjacentDevice>, I>>(base?: I): AdjacentDevice {
    return AdjacentDevice.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<AdjacentDevice>, I>>(object: I): AdjacentDevice {
    const message = createBaseAdjacentDevice();
    message.deviceId = object.deviceId ?? "";
    message.nodeId = object.nodeId ?? "";
    message.nodeName = object.nodeName ?? "";
    message.fabricId = object.fabricId ?? "";
    message.fabricName = object.fabricName ?? "";
    message.portName = object.portName ?? "";
    return message;
  },
};

function createBaseDiscoveredDevice(): DiscoveredDevice {
  return { deviceId: "", deviceName: "", serialNumber: "", modelName: "", connectedDevices: [] };
}

export const DiscoveredDevice: MessageFns<DiscoveredDevice> = {
  encode(message: DiscoveredDevice, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.deviceId !== "") {
      writer.uint32(10).string(message.deviceId);
    }
    if (message.deviceName !== "") {
      writer.uint32(18).string(message.deviceName);
    }
    if (message.serialNumber !== "") {
      writer.uint32(26).string(message.serialNumber);
    }
    if (message.modelName !== "") {
      writer.uint32(34).string(message.modelName);
    }
    for (const v of message.connectedDevices) {
      AdjacentDevice.encode(v!, writer.uint32(42).fork()).join();
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): DiscoveredDevice {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseDiscoveredDevice();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.deviceId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.deviceName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.serialNumber = reader.string();
          continue;
        }
        case 4: {
          if (tag !== 34) {
            break;
          }

          message.modelName = reader.string();
          continue;
        }
        case 5: {
          if (tag !== 42) {
            break;
          }

          message.connectedDevices.push(AdjacentDevice.decode(reader, reader.uint32()));
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): DiscoveredDevice {
    return {
      deviceId: isSet(object.deviceId) ? globalThis.String(object.deviceId) : "",
      deviceName: isSet(object.deviceName) ? globalThis.String(object.deviceName) : "",
      serialNumber: isSet(object.serialNumber) ? globalThis.String(object.serialNumber) : "",
      modelName: isSet(object.modelName) ? globalThis.String(object.modelName) : "",
      connectedDevices: globalThis.Array.isArray(object?.connectedDevices)
        ? object.connectedDevices.map((e: any) => AdjacentDevice.fromJSON(e))
        : [],
    };
  },

  toJSON(message: DiscoveredDevice): unknown {
    const obj: any = {};
    if (message.deviceId !== "") {
      obj.deviceId = message.deviceId;
    }
    if (message.deviceName !== "") {
      obj.deviceName = message.deviceName;
    }
    if (message.serialNumber !== "") {
      obj.serialNumber = message.serialNumber;
    }
    if (message.modelName !== "") {
      obj.modelName = message.modelName;
    }
    if (message.connectedDevices?.length) {
      obj.connectedDevices = message.connectedDevices.map((e) => AdjacentDevice.toJSON(e));
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<DiscoveredDevice>, I>>(base?: I): DiscoveredDevice {
    return DiscoveredDevice.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<DiscoveredDevice>, I>>(object: I): DiscoveredDevice {
    const message = createBaseDiscoveredDevice();
    message.deviceId = object.deviceId ?? "";
    message.deviceName = object.deviceName ?? "";
    message.serialNumber = object.serialNumber ?? "";
    message.modelName = object.modelName ?? "";
    message.connectedDevices = object.connectedDevices?.map((e) => AdjacentDevice.fromPartial(e)) || [];
    return message;
  },
};

function createBaseClaimedDevice(): ClaimedDevice {
  return { deviceId: "", deviceName: "", fabricId: "" };
}

export const ClaimedDevice: MessageFns<ClaimedDevice> = {
  encode(message: ClaimedDevice, writer: BinaryWriter = new BinaryWriter()): BinaryWriter {
    if (message.deviceId !== "") {
      writer.uint32(10).string(message.deviceId);
    }
    if (message.deviceName !== "") {
      writer.uint32(18).string(message.deviceName);
    }
    if (message.fabricId !== "") {
      writer.uint32(26).string(message.fabricId);
    }
    return writer;
  },

  decode(input: BinaryReader | Uint8Array, length?: number): ClaimedDevice {
    const reader = input instanceof BinaryReader ? input : new BinaryReader(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseClaimedDevice();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
        case 1: {
          if (tag !== 10) {
            break;
          }

          message.deviceId = reader.string();
          continue;
        }
        case 2: {
          if (tag !== 18) {
            break;
          }

          message.deviceName = reader.string();
          continue;
        }
        case 3: {
          if (tag !== 26) {
            break;
          }

          message.fabricId = reader.string();
          continue;
        }
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skip(tag & 7);
    }
    return message;
  },

  fromJSON(object: any): ClaimedDevice {
    return {
      deviceId: isSet(object.deviceId) ? globalThis.String(object.deviceId) : "",
      deviceName: isSet(object.deviceName) ? globalThis.String(object.deviceName) : "",
      fabricId: isSet(object.fabricId) ? globalThis.String(object.fabricId) : "",
    };
  },

  toJSON(message: ClaimedDevice): unknown {
    const obj: any = {};
    if (message.deviceId !== "") {
      obj.deviceId = message.deviceId;
    }
    if (message.deviceName !== "") {
      obj.deviceName = message.deviceName;
    }
    if (message.fabricId !== "") {
      obj.fabricId = message.fabricId;
    }
    return obj;
  },

  create<I extends Exact<DeepPartial<ClaimedDevice>, I>>(base?: I): ClaimedDevice {
    return ClaimedDevice.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<ClaimedDevice>, I>>(object: I): ClaimedDevice {
    const message = createBaseClaimedDevice();
    message.deviceId = object.deviceId ?? "";
    message.deviceName = object.deviceName ?? "";
    message.fabricId = object.fabricId ?? "";
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}

export interface MessageFns<T> {
  encode(message: T, writer?: BinaryWriter): BinaryWriter;
  decode(input: BinaryReader | Uint8Array, length?: number): T;
  fromJSON(object: any): T;
  toJSON(message: T): unknown;
  create<I extends Exact<DeepPartial<T>, I>>(base?: I): T;
  fromPartial<I extends Exact<DeepPartial<T>, I>>(object: I): T;
}
